import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useRouteSeo } from "../seo/useRouteSeo";

const setMeta = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("link") ? "link" : "meta");
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
};

// Applies the shared SEO map (src/seo/routes.js) on every navigation so the
// live DOM matches the pre-rendered HTML shipped at build time.
export function RouteSeo() {
  const { pathname } = useLocation();
  const seo = useRouteSeo(pathname);
  useEffect(() => {
    if (!seo) return;
    document.title = seo.title;
    setMeta('meta[name="description"]', { name: "description", content: seo.description });
    setMeta('link[rel="canonical"]', { rel: "canonical", href: seo.canonical });
    setMeta('meta[property="og:title"]', { property: "og:title", content: seo.title });
    setMeta('meta[property="og:description"]', { property: "og:description", content: seo.description });
    setMeta('meta[property="og:url"]', { property: "og:url", content: seo.canonical });
    setMeta('meta[property="og:type"]', { property: "og:type", content: seo.ogType || "website" });
    setMeta('meta[property="og:image"]', { property: "og:image", content: seo.image });
    setMeta('meta[name="twitter:title"]', { name: "twitter:title", content: seo.title });
    setMeta('meta[name="twitter:description"]', { name: "twitter:description", content: seo.description });
    setMeta('meta[name="twitter:image"]', { name: "twitter:image", content: seo.image });
    setMeta('meta[name="robots"]', { name: "robots", content: seo.noindex ? "noindex, nofollow" : "index, follow" });
    document.head.querySelectorAll('script[data-route-seo="jsonld"]').forEach((n) => n.remove());
    if (seo.jsonLd) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-route-seo", "jsonld");
      script.textContent = JSON.stringify(seo.jsonLd);
      document.head.appendChild(script);
    }
  }, [seo]);
  return null;
}
